import { useState, useEffect, useCallback } from 'react';

/**
 * Autoplaying carousel state hook. Stops autoplay on user interaction.
 */
export const useCarousel = (length, intervalMs = 5000) => {
  const [index, setIndex] = useState(0);
  const [isAutoPlaying, setAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying || length <= 1) return undefined;
    const id = setInterval(() => setIndex((p) => (p + 1) % length), intervalMs);
    return () => clearInterval(id);
  }, [isAutoPlaying, length, intervalMs]);

  const next = useCallback(() => {
    setIndex((p) => (p + 1) % length);
    setAutoPlaying(false);
  }, [length]);

  const prev = useCallback(() => {
    setIndex((p) => (p - 1 + length) % length);
    setAutoPlaying(false);
  }, [length]);

  const goTo = useCallback((i) => {
    setIndex(i);
    setAutoPlaying(false);
  }, []);

  return { index, next, prev, goTo };
};
